; var cwMjs = window.cwMjs || {};

import lozad from 'lozad';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';
// init Swiper:
const swiper = new Swiper('.swiper', {
    modules: [Navigation, Pagination, Autoplay],
    // Optional parameters
    loop: true,
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: {
        delay: 8000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();


//是否滚动到底部
function scrollPageAtBottom() {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    return scrollHeight - (scrollTop + windowHeight) < 1;
}

/**
 * article
 * @type {{commentFlag: boolean, mood: Window.cwMjs.article.mood, ajaxAddArticleMood: Window.cwMjs.article.ajaxAddArticleMood, moodCount: Window.cwMjs.article.moodCount, comment: Window.cwMjs.article.comment, loadActionsData: Window.cwMjs.article.loadActionsData}}
 */
cwMjs.article = {

    ajaxAddArticleMood: function ($item) {
        const id = $item.data('id');
        const mood = $item.data('mood');

        let request = $.ajax({
            url: '/api/v1/articles/' + id + '/moods',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                mood: mood
            }
        });

        request.done(function (result) {
            // 投票成功后，如果返回了完整的心情数据，使用updateMoodData更新
            if (result.data && result.data.moods) {
                // console.log(result.data.moods);
                cwMjs.article.updateMoodData(result.data.moods);
            }
            else {
                alert(result.message);
            }
        }).fail(function (jqXHR, textStatus) {
            let message = jqXHR.responseJSON.message
            if (message) {
                alert(message);
                return
            }
            alert("投票失败")
        })
    },

    moodCount: function () {
        var $items = $('.js-mood-box .mood_item');
        var maxNum = null;
        $items.each(function () {
            var $this = $(this);
            var tmpNum = Number($this.data('value'));
            if (maxNum === null) {
                maxNum = Number($this.data('value'));
            } else {
                if (maxNum < tmpNum) {
                    maxNum = tmpNum;
                }
            }
        });

        if (maxNum === 0) return;

        $items.each(function () {
            var $this = $(this);
            var val = Number($this.data('value'));
            var H = Math.ceil(val / maxNum * 100);//100:Max-height of pillar ;
            $this.find('.count').text(val).siblings('.pillar').css({ height: 0 }).animate({ height: H + 2 }, 600);
        })
    },

    mood: function () {
        var $items = $('.js-mood-box .mood_item');
        // console.log(this)
        cwMjs.article.moodCount();

        $.each($items, function (index, item) {
            var $item = $(item);
            $item.on('change', '.change_mood', function (e) {
                e.preventDefault();
                if ($items.is('input:checked')) {
                    alert('您已经表过态了。');
                    return;
                }

                cwMjs.article.ajaxAddArticleMood($item);
                $item.addClass('on');
            });
        });
    },

    commentFlag: false,

    comment: function () {
        var $list = $('.ds-service-list li');
        if ($list.length) {
            if (!cwMjs.common.isWeiXin()) {
                $list.find('.ds-weixin').closest('li').addClass('hide');
            }
            cwMjs.article.commentFlag = true;
        }
    },

    /**
     * 加载文章行为数据（点击量、心情数据）
     */
    loadActionsData: function () {
        // console.log('loadActionsData method called!');

        const $viewCount = $('#articleViewCount');
        const $moodBox = $('#articleMoodBox');

        if (!$viewCount.length && !$moodBox.length) {
            return;
        }

        const articleId = $viewCount.data('article-id') || $moodBox.data('article-id');
        if (!articleId) {
            return;
        }

        // console.log('Loading article actions data for article ID:', articleId);

        $.ajax({
            url: `/api/v1/articles/${articleId}/actions-data`,
            method: 'POST',
            dataType: 'json',
            success: function (result) {
                if (result.data) {
                    // 更新点击量
                    if ($viewCount.length && result.data.views !== undefined) {
                        $viewCount.find('.count-number').text(result.data.views);
                        // console.log('Updated view count to:', result.data.views);
                    }

                    // 更新心情数据
                    if ($moodBox.length && result.data.moods && result.data.moods.moods) {
                        cwMjs.article.updateMoodData(result.data.moods.moods);
                        // console.log('Updated mood data:', result.data.moods.moods);     
                    }
                }
            },
            error: function (xhr, status, error) {
                console.error('Failed to load article actions data:', error);
            }
        });
    },

    /**
     * 更新心情数据
     */
    updateMoodData: function (moods) {
        const $moodItems = $('.js-mood-box .mood_item');

        $moodItems.each(function () {
            const $item = $(this);
            const moodField = $item.data('mood');

            // 查找对应的心情数据
            const moodData = moods[moodField];
            if (moodData && moodData.value !== undefined) {
                // 更新数值
                $item.data('value', moodData.value);
                $item.find('.count').text(moodData.value);

                // 重新计算心情柱状图
                cwMjs.article.moodCount();
            }
        });
    }
};

/**
 * author
 * @type {{switchAuthorIndex: Window.cwMjs.author.switchAuthorIndex}}
 */
cwMjs.author = {
    switchAuthorIndex: function () {

        $('h2 .btn-index').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('hide').siblings('a').removeClass('hide');
            $('.author-list-box').addClass('hide');
            $('.author-index-list').removeClass('hide');
        });

        $('h2 .btn-detail').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('hide').siblings('a').removeClass('hide');
            $('.author-list-box').removeClass('hide');
            $('.author-index-list').addClass('hide');
        });

    }
};

/**
 * cloumn
 */


cwMjs.column = {
    page: 1,
    loadFlag: true,

    init: function () {

    },

    createArticleList: function (articles, type) {
        var $articleWrap = $('.js-article-list');
        if ($articleWrap.length) {
            $.each(articles, function (index, article) {
                $articleWrap.append(cwMjs.column.createArticleElement(article));
            });
        }
    },

    createArticleElement: function (article) {
        var content = '';
        if (article.titlepic) {
            content += '<li class="item-img-single clearfix">';
            content += '<a class="img-box" href="' + article.url + '" title="' + article.title + '" target="_self">';
            content += '<img src="' + article.titlepic + '" alt="' + article.title + '" >';
            // content += '<img className="lozad" data-src="' + article.titlepic + '" data-placeholder-background="#fefefe" src="' + article.defaultImage + '" alt="' + article.title + '"/>'
            content += '</a >';
            content += '<div class="article-info">';
            content += '<h3><a href="' + article.url + '" title="' + article.title + '" target="_self">' + article.formatTitle + '</a ></h3>';
            content += '<div>';
            content += article.authorRender;
            content += '<span class="date">' + article.newstime + '</span>';
            content += '</div>';
            content += '</div>';
            content += '</li>';
        } else {
            content += '<li class="item-article clearfix">';
            content += '<div class="article-info">';
            content += '<h3><a href="' + article.url + '" title="' + article.title + '" target="_self">' + article.formatTitle + '</a ></h3>';
            content += '<div>';
            content += article.authorRender;
            content += '<span class="date">' + article.newstime + '</span>';
            content += '</div>';
            content += '</div>';
            content += '</li>';
        }

        return $(content);
    },

    ajaxGetMoreArticles: function ($loader) {
        // page + 1
        cwMjs.column.page++;
        const type = $loader.data('type')
        const key = $loader.data('key')
        var request = $.ajax({
            url: '/api/v1/articles/more',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page: cwMjs.column.page,
                pageSize: 15,
                type: type,
                key: key
            }
        });

        request.done(function (result) {
            let data = result.data;
            let meta = result.meta;
            let last_page = meta.last_page;
            let current_page = meta.current_page;
            if (data.length === 0 || last_page === current_page) {
                cwMjs.column.loadFlag = false;
                $loader.html('没有更多文章了');
            } else {
                setTimeout(function () {
                    cwMjs.column.createArticleList(data, type);
                    $loader.html('查看更多');
                    cwMjs.column.loadFlag = true;
                }, 1000);
            }
        });
    },

    articlesLoadMore: function () {
        let $loader = $('.js-articles-load-more');
        $loader.on('click', function () {
            if (cwMjs.column.loadFlag === true) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxGetMoreArticles($loader);
            }
        });

        $(window).scroll(function () {
            //滚动条到底部触发
            if (scrollPageAtBottom() && cwMjs.column.loadFlag) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxGetMoreArticles($loader);
            }
        });
    },

    createAuthorList: function (authors) {
        var $authorWrap = $('.js-author-list');
        if ($authorWrap.length) {
            $.each(authors, function (index, author) {
                var content = '<li class="clearfix">';
                content += ' <a href="' + author.url + '" class="img-box" title="' + author.title + '" target="_self" >';
                content += '<img src="' + author.titlepic + '" alt="' + author.title + '" >';
                content += ' </a >';
                content += '<a href="' + author.url + '" class="author-info" title="' + author.title + '" target="_self" >';
                content += '<h3>' + author.title + '</h3>';
                content += '<div class="title">' + author.ftitle + '</div>';
                content += '<span class="article-count">文章' + author.articleCount + '篇</span>';
                content += '</a >';
                content += '</li>';
                $authorWrap.append($(content));
            });
        }
    },

    ajaxAuthorLoad: function ($loader) {
        cwMjs.column.page++;
        var request = $.ajax({
            url: '/api/v1/authors/more',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page: cwMjs.column.page,
                pageSize: 15
            }
        });

        request.done(function (result) {
            let data = result.data;
            let meta = result.meta;
            let last_page = meta.last_page;
            let current_page = meta.current_page;
            if (data.length === 0 || last_page === current_page) {
                $loader.html('没有更多作者了');
            } else {
                cwMjs.column.createAuthorList(data);
                $loader.html('查看更多');
                cwMjs.column.loadFlag = true;
            }
        });
    },

    authorLoad: function () {
        let $loader = $('.js-author-load');
        $loader.on('click', function () {
            if (cwMjs.column.loadFlag) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxAuthorLoad($loader);
            }
        });

        $(window).scroll(function () {
            //滚动条到底部触发
            if (scrollPageAtBottom() && cwMjs.column.loadFlag) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxAuthorLoad($loader);
            }
        });
    },

    createTopicList: function (topics) {
        let $topicWrap = $('.js-topic-list');
        if ($topicWrap.length) {
            $.each(topics, function (index, topic) {
                var content = '<li class="item-img-single clearfix">';
                content += '<a class="img-box" href="' + topic.url + '" title="' + topic.ztname + '" target="_self">';
                content += '<img src="' + topic.ztimg + '" >';
                content += ' </a >';
                content += '<div class="article-info">';
                content += '<h3><a href="' + topic.url + '" title="' + topic.ztname + '" target="_self">' + topic.ztname + '</a ></h3>';
                content += '<div>';
                content += '<span class="article-count">文章' + topic.articleCount + '篇</span>';
                content += '</div>';
                content += '</div>';
                content += ' </li>';
                $topicWrap.append($(content));
            });
        }
    },

    ajaxTopicLoad: function ($loader) {
        cwMjs.column.page++;
        let request = $.ajax({
            url: '/api/v1/specials/more',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                page: cwMjs.column.page,
                pageSize: 15
            }
        });

        request.done(function (result) {
            let data = result.data;
            let meta = result.meta;
            let last_page = meta.last_page;
            let current_page = meta.current_page;
            if (data.length === 0 || last_page === current_page) {
                $loader.html('没有更多专题了');
            } else {
                cwMjs.column.createTopicList(data);
                $loader.html('查看更多');
                cwMjs.column.loadFlag = true;
            }
        });
    },

    topicLoad: function () {
        let $loader = $('.js-topic-load');
        $loader.on('click', function () {
            if (cwMjs.column.loadFlag === true) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxTopicLoad($loader);
            }
        });

        $(window).scroll(function () {
            //滚动条到底部触发
            if (scrollPageAtBottom() && cwMjs.column.loadFlag) {
                cwMjs.column.loadFlag = false;
                $loader.html("正在加载中...")
                cwMjs.column.ajaxTopicLoad($loader);
            }
        });
    }
};
/**
 * common
 */


cwMjs.common = {
    ajaxSetup: function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
    },

    showNav: function () {
        $('.btn_side').on('click', function () {
            let icon = $(this).find("i");
            // console.log(icon)
            let status = icon.hasClass('open');
            // console.log(status)
            if (status) {
                icon.removeClass('open');
            } else {
                icon.addClass("open")
            }

            $('.nav-container').slideToggle(200);
        });
    },

    switchToWeb: function () {
        $('.switch-to-web').on('click', function (e) {
            e.preventDefault();
            var url = window.location.href.toString().replace('m', 'www');
            var list = url.split('/');
            if (list.pop() == 'special') {
                url += '.html';
            }
            Cookies.set('jump_key', 'desk', { domain: 'hswh.org.cn', expires: 1 });
            window.location.href = url;
        });
    },

    isWeiXin: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    }

    , fixedFooter: function () {
        initFooter();

        function initFooter() {
            var winH = $(window).height();
            var bodyH = $(document.body).height();
            var footerH = $('footer').height();

            if (winH >= bodyH + footerH || !$('footer').hasClass('fixed-footer') && winH >= bodyH) {
                $('footer').css({ position: 'fixed', width: '100%', left: 0, bottom: 0 }).addClass('fixed-footer');
            } else if ($('footer').hasClass('fixed-footer') && winH < bodyH + footerH) {
                $('footer').css({ position: 'static', left: 'auto', bottom: 'auto' }).removeClass('fixed-footer');
            }
        }

        $(window).on('resize', function () {
            initFooter();
        })
    }

    , backTop: function () {
        var $btn = $('.btn-back-top');

        $btn.on('click', function () {
            $('html,body').animate({ scrollTop: 0 }, 400);
        });

        $(window).on('scroll', function () {
            var scrollTop = $(window).scrollTop();
            var limit = 600;

            if (scrollTop > limit && $btn.hasClass('out-hide')) {
                $btn.removeClass('out-hide');
                return;
            }

            if (scrollTop <= limit && !$btn.hasClass('out-hide')) {
                $btn.addClass('out-hide');
            }
        });
    },

    open_side: function () {
        var $btn_side = $('header .btn_side');
        var $box_side = $('#nav_model');
        var $body = $('body');

        $box_side.on('click', function () {
            $box_side.removeClass('open');
            $body.removeClass('fixed')
        })

        $btn_side.on('click', function (e) {
            $box_side.addClass('open');
            $body.addClass('fixed');
        })
    }
}

/**
 * index
 */

cwMjs.index = {
    init: function () {
        var $slide = $('.hot-list .flexslider');

        $slide.flexslider({
            slideshow: false,
            animationLoop: true,
            animation: 'slide',
            directionNav: false
        });
    }
};


/**
 * init
 */

$(function () {
    // console.log('DOM ready event fired');

    // 确保DOM完全加载后再执行
    $(document).ready(function () {
        // console.log('Document ready event fired');

        setTimeout(function () {
            // console.log('Timeout executed, starting initialization...');    

            function init(el, fn) {
                if ($(el).length > 0 && typeof fn === 'function') fn(el);
            }

            init('.js-ajax', cwMjs.common.ajaxSetup);
            //index
            init('.p-index', cwMjs.index.init);

            //article
            init('.js-mood-box', cwMjs.article.mood);
            init('.js-articles-load-more', cwMjs.column.articlesLoadMore);
            init('.js-author-load', cwMjs.column.authorLoad);
            init('.js-topic-load', cwMjs.column.topicLoad);

            // 加载文章行为数据（点击量、心情数据）
            if ($('#articleViewCount').length || $('#articleMoodBox').length) {
                // console.log('Article elements found, calling loadActionsData...');
                cwMjs.article.loadActionsData();
            }

            //author
            init('.author-index-list', cwMjs.author.switchAuthorIndex);

            //common
            init('.btn_side', cwMjs.common.showNav);
            init('footer', cwMjs.common.fixedFooter);
            init('.btn-back-top', cwMjs.common.backTop);

        }, 2);
    });
});
